import { render, staticRenderFns } from "./CapsuleCard.vue?vue&type=template&id=42db5ec6"
import script from "./CapsuleCard.vue?vue&type=script&lang=js"
export * from "./CapsuleCard.vue?vue&type=script&lang=js"
import style0 from "./CapsuleCard.vue?vue&type=style&index=0&id=42db5ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports